import { Modal, ModalProps } from "antd";

const Dialog = (props: ModalProps) => <Modal {...props} />;

export default Dialog;
